

import React, {useState} from 'react';
import {Container, NavDropdown, Nav, Navbar, Form, FormControl,Button, Row, Offcanvas } from 'react-bootstrap'
import $ from "jquery"
import { Link } from 'react-router-dom';
import "../stylesheets/style.css"
import "../stylesheets/navbar.css"
import "../js/main.js"


const TopBar = () => {
  const name = localStorage.getItem("userfirstname") + localStorage.getItem("userlastname") 
  const [Userintro, SetUserIntro] = useState(name)

    $(document).ready(function () {
            $('#sidebarCollapse').on('click', function () {
                $('#sidebar').toggleClass('active');
            });
        });

        
return(

//     <nav class="navbar navbar-expand-lg navbar-light bg-light" id="webappnavbar">
//     <div class="container-fluid">

//         <button type="button" id="sidebarCollapse" class="btn btn-info formobileonly">
//             <i class="fas fa-align-left"></i>
//             <span>Toggle Sidebar</span>
//         </button>


//         <div className='row'>
//             <div class="col-md-4">
//             <p><span className="welcomespan1">Welcome Christian</span><br/><span className="welcomespan2">Its a sunny day</span></p>

//             </div>

//             <div class="col-md-4">
//             <div class="main">
  
//   <div class="form-group has-search">
//     <span class="fa fa-search form-control-feedback"></span>
//     <input type="text" class="form-control" placeholder="Search"/>
//   </div>
 
// </div>

//             </div>

//             <div class="col-md-4">

//             </div>
//         </div>

//         <button class="btn btn-dark d-inline-block d-lg-none ml-auto" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
//             <i class="fas fa-align-justify"></i>
//         </button>

   


//         <div class="collapse navbar-collapse" id="navbarSupportedContent">
//             <ul class="nav navbar-nav ml-auto">

   
//                 <li class="nav-item">
//                     <a class="nav-link" href="#"><img src="./images/avatar.png"/></a>
//                 </li>
//             </ul>
//         </div>
//     </div>
// </nav>


//         <button type="button" id="sidebarCollapse" class="btn btn-info formobileonly">
//             <i class="fas fa-align-left"></i>
//             <span>Toggle Sidebar</span>
//         </button>

<div class="row topbarheader">

    <div class="col-md-3">
           <button type="button" id="sidebarCollapse" class="btn btn-info formobileonly">
           <i class="fas fa-align-left"></i>
             <span>Toggle Sidebar</span>
         </button>

    <p className='topbarheadermenu'>
      <span className="welcomespan1">Welcome {Userintro}<img style={{float:"right", paddingTop:"10px"}} src="./images/message.png"/></span><br/><span className="welcomespan2">Its a sunny day</span></p>

    </div>

    <div class="col-md-1"></div>

    <div class="col-md-4 topbarheadermenu2">
    <div class="main">
  
  <div class="form-group has-search">
    <span class="fa fa-search form-control-feedback"></span>
    <input type="text" class="form-control" placeholder="Search"/>
  </div>
 
</div>
    </div>
    <div class="col-md-4 topbarheadermenu2">
 
    </div>
</div>
)

};


export default TopBar;